import { Modal } from "@general-backoffice/core/index";
import type { PayoutsWallet } from "@investhinks/api-client";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";

import StatsSummaryCard from "../../shared/StatsSummaryCard";

interface PayoutWalletCardProps {
  payout: Partial<PayoutsWallet> | null | undefined;
  isLoading: boolean;
  onClaim: (() => void) | null;
}

const PayoutWalletCard = ({ payout, isLoading, onClaim }: PayoutWalletCardProps) => {
  const { amount, claimedAmount, collectable = true, uncollectableReasons = [] } = payout || {};
  const { t } = useTranslation("referrer", { keyPrefix: "partner.payoutWalletCard" });
  const [isOpenModalInfo, setIsOpenModalInfo] = React.useState(false);
  const [isOpenModalNoCollectable, setIsOpenModalNoCollectable] = React.useState(false);

  const getNum = (num: number | undefined) => (!isLoading ? (num || 0).toFixed(2) : "--.--") + " €";

  const stats = [{ title: t("totalSubtitle"), stat: getNum(claimedAmount) }];

  return (
    <>
      <Modal.Info titleInfo={t("infoTitle")} isOpen={isOpenModalInfo} toggleOpen={() => setIsOpenModalInfo(false)}>
        {t("infoText")}
      </Modal.Info>
      <Modal.Simple
        title={t("noCollectableTitle")}
        isOpen={isOpenModalNoCollectable}
        toggleOpen={() => setIsOpenModalNoCollectable(false)}
      >
        {t("noCollectableText")}
        <ul className={"mt-3"}>
          {uncollectableReasons.map((r: string, i: number) => (
            <li key={i}>{t(`noCollectableMessages.${r}`)}</li>
          ))}
        </ul>
      </Modal.Simple>

      <StatsSummaryCard
        mainStat={<div className="text-success">{getNum(amount)}</div>}
        mainTitle={t("subtitle")}
        stats={stats}
        color="white"
        topRight={
          <div className="flex-center text-nowrap" style={{ gap: "1rem" }}>
            <Button
              disabled={isLoading || !onClaim}
              onClick={() => (collectable ? onClaim?.() : setIsOpenModalNoCollectable(true))}
              color={"success"}
              style={{ opacity: onClaim ? 1 : 0 }}
            >
              {!collectable && <i className="fas fa-exclamation-triangle" />} {t("claim")}
            </Button>
            <Button
              className="h3 m-0 shadow-none"
              onClick={() => setIsOpenModalInfo(true)}
              aria-label={t("moreInfo")}
              title={t("moreInfo")}
            >
              <i className="fas fa-info-circle" aria-hidden="true" />
            </Button>
          </div>
        }
      />
    </>
  );
};

export default PayoutWalletCard;
